export default "__VITE_ASSET__DAiU8Lv3__"